import React from 'react';
import "./App.css";
import AppRouter from './routes/AppRouter';
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { captureAttributionOnce } from './utils/attribution';

// RSEV-87: capture marketing attribution (URL params, falling back to the
// rs_ft/rs_lt cookies) as early as possible - before AppRouter's first
// render, so a route/auth redirect never has a chance to drop the query
// string first. Runs once per module load, which is once per page load.
captureAttributionOnce();

const App: React.FC = () => {
  return (
    <>
      <AppRouter />
      <ToastContainer
        position="top-right"
        autoClose={10000}
        hideProgressBar={true}
        closeButton={false}
        closeOnClick={true}
        pauseOnHover={true}
        draggable={false}
        limit={1}
        newestOnTop={true}
      />
    </>
  );
};

export default App;